export function range(n) {
    const out = new Array(n);
    for (let i = 0; i < n; i++) {
        out[i] = i;
    }
    return out;
}
export function rangeWithStart(start = 0, stop = 0, step = 1) {
    if (step == 1) {
        return rangeWithStartStep1(start, stop);
    }
    const out = new Array(Math.ceil((stop - start) / step));
    for (let x = start, i = 0; x < stop; x += step) {
        out[i++] = x;
    }
    return out;
}
export function rangeWithStartStep1(start = 0, stop = 0) {
    if (start == 0) {
        return range(stop);
    }
    const out = new Array(stop - start);
    for (let x = start, i = 0; x < stop; x++) {
        out[i++] = x;
    }
    return out;
}
export const wrapFunction = (a, fn) => {
    return (...args) => a(fn.apply(args));
};
export function keysOf(object) {
    return Object.keys(object);
}
export function valuesOf(object) {
    return Object.values(object);
}
export function entriesOf(object) {
    return Object.entries(object);
}
export function removeUndefinedKeys(object) {
    return entriesOf(object)
        .filter((pair) => pair[1] !== undefined)
        .reduce((obj, [k, v]) => {
        obj[k] = v;
        return obj;
    }, {});
}
export function isPresent(o) {
    return o !== null && o !== undefined;
}
export function filterUndefined(x) {
    return x !== undefined;
}
export function isArrEqual(a, b, cmp = (x, y) => x === y) {
    if (a === undefined) {
        return b === undefined;
    }
    return b !== undefined && a.length === b.length && a.every((x, i) => cmp(x, b[i]));
}
export function compareNumeric(a, b) {
    const diff = a - b;
    if (isFinite(diff)) {
        return diff;
    }
    else if (a == b || (isNaN(a) && isNaN(b))) {
        return 0;
    }
    else if (a == -Infinity || b == Infinity || isNaN(a)) {
        return -1;
    }
    else if (a == Infinity || b == -Infinity || isNaN(b)) {
        return 1;
    }
    else {
        return 0;
    }
}
export function compareBoolean(a, b) {
    return a === b ? 0 : a ? 1 : -1;
}
export function compareString(a, b) {
    return a.localeCompare(b);
}
export function getDefaultNumericComparator() {
    return compareNumeric;
}
export function getNumericComparator(keyExtractor) {
    return getComparator(keyExtractor, compareNumeric);
}
export function getStringComparator(keyExtractor) {
    return getComparator(keyExtractor, compareString);
}
export function getBooleanComparator(keyExtractor) {
    return getComparator(keyExtractor, compareBoolean);
}
export function getComparator(keyExtractor, comparator) {
    return (a, b) => {
        return comparator(keyExtractor(a), keyExtractor(b));
    };
}
export function reverseOrder(comparator) {
    return (a, b) => {
        return -1 * comparator(a, b);
    };
}
export function chainComparators(comparators) {
    return (a, b) => {
        for (let i = 0; i < comparators.length; i++) {
            const res = comparators[i](a, b);
            if (res != 0) {
                return res;
            }
        }
        return 0;
    };
}
function _binarySearch(array, key, comparator, lower = 0, upper = array.length - 1) {
    if (upper === undefined) {
        upper = array.length - 1;
    }
    if (comparator(key, array[lower]) <= 0) {
        upper = lower;
    }
    else if (comparator(key, array[upper]) >= 0) {
        lower = upper;
    }
    while (lower <= upper) {
        const middle = (lower + upper) >> 1;
        const comparison = comparator(array[middle], key);
        if (comparison < 0) {
            lower = middle + 1;
        }
        else if (comparison > 0) {
            upper = middle - 1;
        }
        else {
            return middle;
        }
    }
    return -(lower + 1); // key not found
}
export var SearchMode;
(function (SearchMode) {
    SearchMode[SearchMode["Exact"] = 0] = "Exact";
    SearchMode[SearchMode["NearestAbove"] = 1] = "NearestAbove";
    SearchMode[SearchMode["NearestBelow"] = 2] = "NearestBelow";
})(SearchMode || (SearchMode = {}));
export function binarySearchNumeric(array, key, mode = SearchMode.Exact, lower = 0, upper = array.length - 1) {
    const comparator = getDefaultNumericComparator();
    return binarySearch(array, key, comparator, mode, lower, upper);
}
export function binarySearch(array, key, compare, mode = SearchMode.Exact, lower = 0, upper = array.length - 1) {
    const result = _binarySearch(array, key, compare, lower, upper);
    if (result >= 0) {
        return result;
    }
    const insertionIndex = -result - 1;
    switch (mode) {
        case SearchMode.Exact:
            return result;
        case SearchMode.NearestAbove:
            if (insertionIndex < upper) {
                return insertionIndex;
            }
            return upper;
        case SearchMode.NearestBelow:
            if (insertionIndex > lower) {
                return insertionIndex - 1;
            }
            return lower;
        default:
            return result;
    }
}
